import { Button } from '../../ui/button';
import { Card, CardContent } from '../../ui/card';
import { Badge } from '../../ui/badge';
import { TombstoneQuote } from '../../../types/tombstones';
import { formatCurrency, getStatusBadgeVariant, getStatusLabel } from './tombstoneQuoteHelpers';

interface TombstoneMobileCardProps {
  quote: TombstoneQuote;
  onOpenDetails: (quote: TombstoneQuote) => void;
}

export function TombstoneMobileCard({ quote, onOpenDetails }: TombstoneMobileCardProps) {
  return (
    <Card className="shadow-sm overflow-hidden">
      <CardContent className="p-4 space-y-3">
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <div className="font-medium text-sm">{quote.quoteNumber}</div>
              {!quote.isViewed && (
                <Badge variant="destructive" className="text-xs px-1.5 py-0">Novo</Badge>
              )}
            </div>
            <div className="font-semibold break-words">{quote.customerName}</div>
            {quote.customerCompany && (
              <div className="text-xs text-muted-foreground break-words">
                {quote.customerCompany}
              </div>
            )}
          </div>
          <Badge
            variant={getStatusBadgeVariant(quote.status)}
            className="flex-shrink-0"
          >
            {getStatusLabel(quote.status)}
          </Badge>
        </div>

        <div className="space-y-1 text-sm">
          {quote.customerEmail && (
            <div className="flex items-center gap-2 text-muted-foreground">
              <span className="text-xs flex-shrink-0">E-mail:</span>
              <span className="text-foreground break-all">
                {quote.customerEmail.split('@')[0]}<wbr />@{quote.customerEmail.split('@')[1]}
              </span>
            </div>
          )}
          <div className="flex items-center justify-between">
            <span className="text-xs text-muted-foreground">Criado em:</span>
            <span className="text-foreground">
              {new Date(quote.createdAt).toLocaleDateString('pt-BR')}
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between pt-2 border-t">
          <div>
            <div className="text-xs text-muted-foreground">Valor Total</div>
            <div className="text-lg font-semibold">
              {formatCurrency(quote.totalAmount)}
            </div>
          </div>
          <Button
            variant="default"
            size="sm"
            onClick={() => onOpenDetails(quote)}
          >
            Ver detalhes
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
